"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.NewTeamMemberSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<path d="M16,2A7,7,0,0,0,9,9.07V10.5A9,9,0,0,0,12,17c-5.78.86-10,3.83-10,7v4a2,2,0,0,0,2,2H19a.5.5,0,0,0,.39-.81,7,7,0,0,1,2.87-10.64.5.5,0,0,0,0-.92A11.66,11.66,0,0,0,20,17a9.08,9.08,0,0,0,3-6.5V9.07h0A7,7,0,0,0,16,2Z"/><path d="M29,24H26V21a1,1,0,0,0-2,0v3H21a1,1,0,0,0,0,2h3v3a1,1,0,0,0,2,0V26h3a1,1,0,0,0,0-2Z"/>';
var NewTeamMemberSVG = function NewTeamMemberSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.NewTeamMemberSVG = NewTeamMemberSVG;
NewTeamMemberSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(NewTeamMemberSVG);
exports.default = _default;